import { Injectable, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '@src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LobbiChatProvider {
  constructor(
    private readonly rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  public init(autoOpen = false): void {
    const existing = this.document.querySelector(`script[src="${environment.lobbi.scriptSrc}"]`);
    if (existing) {
      return;
    }

    const renderer = this.rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');

    renderer.setAttribute(script, 'src', environment.lobbi.scriptSrc);
    renderer.setAttribute(script, 'data-widget-id', environment.lobbi.widgetId);
    renderer.setAttribute(script, 'data-server', environment.lobbi.server);
    if (autoOpen) {
      renderer.setAttribute(script, 'data-auto-open', 'true');
    }
    renderer.setAttribute(script, 'async', '');

    renderer.appendChild(this.document.body, script);
  }
}
